import React from 'react'
import { Camera, Sparkles } from 'lucide-react'
import { Box, Flex } from '@chakra-ui/core'
import { IconProps } from './types'

/**
 * Camera with a sparkle badge — the subtask-row entry that adds a photo subtask already marked
 * `is_ai_enhanced`. Same 40px circle as the other subtask icons; only the palette differs (the AI
 * pink of `CreateAITaskButton`), so the row still reads as one set.
 */
const AiCameraIcon: React.FC<IconProps> = ({
  // Must match CameraIcon's defaults: call sites that render one or the other off `is_ai_enhanced`
  // (WidgetIcon) pass no size, and a different default makes the glyph jump when the switch is toggled.
  iconWidth = 24,
  iconHeight = 24,
  width = '40px',
  height = '40px',
  iconColor = '#DD367E',
  bgColor = '#FAE2ED',
  ...props
}) => {
  // Scales with the camera so the pair keeps its proportions at every call site (40px row icon,
  // 50px widget header, 72px AI preview).
  const badgeSize = Math.round(iconWidth * 0.57)

  return (
    <Flex
      position="relative"
      justifyContent="center"
      alignItems="center"
      bg={bgColor}
      width={width}
      height={height}
      borderRadius="full"
      {...props}
    >
      <Camera width={iconWidth} height={iconHeight} color={iconColor} />
      {/* Badge overlaps the circle's edge so the pair still occupies a single icon slot in the row */}
      <Box position="absolute" top="0" right="0" bg={bgColor} borderRadius="full" p="1px" lineHeight={0}>
        <Sparkles width={badgeSize} height={badgeSize} color={iconColor} fill={iconColor} />
      </Box>
    </Flex>
  )
}

export default AiCameraIcon
